import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { dueActivitiesCount } from './types';

import { requestDueActivitiesCountSuccess, requestDueActivitiesCountFailure } from './actions';

const logger = new Logger('Saga:FundingSearch:DueActivitiesCount');

export function* requestDueActivitiesCountSaga() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.activities.due_activities_count'),
    );

    yield put(requestDueActivitiesCountSuccess(response.data));
  } catch (error) {
    logger.error('Failed to request due activities count with the following error', error);
    yield put(requestDueActivitiesCountFailure(error));
  }
}

export default function* dueActivitiesCountSaga() {
  return yield all([takeLatest(dueActivitiesCount.request, requestDueActivitiesCountSaga)]);
}
